import {Form} from 'antd';
import moment from 'moment';
import React, {useContext, useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../constants/Common';
import SelectedCountryContext from '../../../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import vehicleAPI from '../../../../services/modules/IP/vehicleAPI';
import vehicleFuelUsedJSON from '../../../../services/modules/JSON/vehicleFuelUsed';
import vehicleTypeAPI from '../../../../services/modules/JSON/vehicleType';
import useJSONStore from '../../../../store/StaticJson/jsonStore';
import VehicleForm from '../../../Forms/VehicleForm';
import Loader from '../../../Loader/Loader';
import {IComponentProps} from '../../Common/perquisiteMaster';

const VehicleBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const {efdbData, facilityId, selectedYear} = useContext(
    SelectedCountryContext
  );
  const year = record?.year ?? selectedYear;
  const facility = record?.facility ?? facilityId;
  const facilityEfdb = efdbData?.[year]?.find(
    (i: any) => i.facilityId === facility
  );
  const initialValues = {
    facility: record?.facility,
    year: record?.year
  };

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        vehicleAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
      vehicleTypeAPI(),
      vehicleFuelUsedJSON()
    ])
      .then(([res1]) => {
        if (res1?.data?.isDeleted === false) {
          caForm.setFieldsValue(res1?.data);
          onValuesChange(true);
        } else {
          const fData: any = record?.fields ?? undefined;

          let fuelTypeUsed = '';

          const vehicleFuelUsed = useJSONStore.getState().vehicleFuelUsed;

          if (vehicleFuelUsed?.length > 0) {
            const res = vehicleFuelUsed.find((item) => {
              const fuelUsed = fData?.fuelUsed?.toLowerCase();

              const words = item.label
                ?.toLowerCase()
                ?.replace(/[()]/g, '') // remove brackets
                ?.split(/[\s\\/-]+/); // split by space, /,

              return (
                words?.includes(fuelUsed) &&
                item?.dbName === facilityEfdb?.scope1
              );
            });

            fuelTypeUsed = res?.value;
          }

          const customFromData: any = {
            _id: '',
            facility: record?.facility,
            timeFrameData: fData?.timeFrameData ?? [],
            fuelUsed: fuelTypeUsed,
            year: record?.year,
            status: 'ready_for_review',
            comment: '',
            dataSource: 'manual'
          };

          caForm.setFieldsValue(customFromData);
        }

        if (res1?.data) {
          caForm.setFieldsValue({
            ...res1?.data,
            assetLessorRentedFrom: res1?.data?.assetLessorRentedFrom
              ? moment(res1?.data?.assetLessorRentedFrom)
              : null,
            assetLessorRentedTo: res1?.data?.assetLessorRentedTo
              ? moment(res1?.data?.assetLessorRentedTo)
              : null
          });
        }
      })
      .catch(() => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <VehicleForm defaultDisplayStep={true} />
    </Form>
  );
};

export default VehicleBills;
